// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"711bf7bd","453":"8b4b26dc","462":"696fb746","481":"79118741"}[chunkId] + ".chunk.js";
};